var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[((_vm.imageSrc) && (!_vm.loadFail))?_c('img',{style:({width: _vm.width, height: _vm.height}),attrs:{"src":_vm.imageSrc,"alt":"event"},on:{"error":_vm.failedLoad}}):(_vm.eventName && _vm.eventInitials)?_c('div',{staticClass:"event-info",style:({
      width: _vm.width,
      height: _vm.height,
    })},[_c('div',{ref:"avatar",staticClass:"event-info-avatar",style:({
      'background-color': _vm.stringToColor,
      'font-size': ((_vm.size.height - _vm.size.height/1.8) + "px"),
    })},[_vm._v(" "+_vm._s(_vm.eventInitials)+" ")])]):_c('img',{staticClass:"empty-image",attrs:{"src":require("../../assets/img/rectangle-border-lg.svg"),"alt":"event"}})])}
var staticRenderFns = []

export { render, staticRenderFns }